import React, { useEffect, useState } from 'react'
import { Button, Checkbox, Popover } from '@mui/material'
import '../../../style/filters.css'

const ApplicationFilter = ({ filterList, onChange, index, column, filterOptions }) => {
  const [tempFilters, setTempFilters] = useState(filterList || [])
  const [anchorEl, setAnchorEl] = useState(null)

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleChange = (event) => {
    const { value, checked } = event.target
    setTempFilters((prev) => (checked ? [...prev, value] : prev.filter((item) => item !== value)))
  }

  //   const handleApply = () => {
  //     onChange(tempFilters, index, column)
  //     handleClose()
  //   }
  const handleApply = () => {
    const cleaned = tempFilters.filter(Boolean) // removes "", null, undefined
    console.log('Applying filters:', cleaned) // Update state with cleaned filters
    onChange(cleaned, index, column)
    handleClose()
  }

  const handleReset = () => {
    setTempFilters([])
    onChange([], index, column)
    handleClose()
  }

  const open = Boolean(anchorEl)
  const id = open ? 'application-filter-popover' : undefined
  useEffect(() => {
    if (open) {
      setTempFilters(filterList || [])
    }
  }, [open, filterList])

  return (
    <div>
      <Button
        aria-describedby={id}
        onClick={handleClick}
        variant="outlined"
        size="small"
        style={{ marginLeft: 8 }}
      >
        Application Filters
      </Button>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        PaperProps={{
          style: {
            backgroundColor: '#000000', // Black background
            color: '#ffffff', // White text
            padding: '16px',
            width: '300px',
            borderRadius: '4px',
            boxShadow: '0px 5px 15px rgba(0, 0, 0, 0.3)',
          },
        }}
      >
        <div style={{ padding: '8px' }}>
          <h3 className="filter-title">Application Filters</h3>

          <div
            style={{
              maxHeight: '300px',
              overflow: 'auto',
              marginBottom: '16px',
            }}
          >
            {filterOptions.applications?.map((app, i) => (
              <div
                key={i}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  padding: '4px 0',
                }}
              >
                <Checkbox
                  checked={tempFilters.includes(app)}
                  onChange={handleChange}
                  value={app}
                  size="small"
                  style={{ color: '#ffffff' }}
                />
                <span
                  style={{
                    fontSize: '0.875rem',
                    lineHeight: '1.5',
                    color: 'inherit',
                    marginLeft: '8px',
                  }}
                >
                  {app}
                </span>
              </div>
            ))}
          </div>

          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
            }}
          >
            <button onClick={handleApply} className="apply-button-filter">
              Apply
            </button>
            <button onClick={handleReset} className="reset-button-filter">
              Reset
            </button>
          </div>
        </div>
      </Popover>
    </div>
  )
}

export default ApplicationFilter
